export class StickerGridTemplateFactory {
  constructor(emptyStickers, cols, rows, margin, pad, size, pdfProperties) {
    this.cols = cols;
    this.rows = rows;
    this.emptyStickers = emptyStickers;
    this.margin = margin;
    this.pad = pad;
    this.size = size;
    this.pdfProperties = pdfProperties;
  }
}
